import Button from 'antd/lib/button';
import styled from 'styled-components';

export const StyledButton: typeof Button = styled(Button)``;
